<template>
	<span class="title-anim">
		<Transition name="title">
			<span v-text="title" :key="title"></span>
		</Transition>
	</span>
</template>

<script>

export default {
	computed: {
		/* Title to be displayed; sourced from the store, which title.js keeps up to date */
		title() {
			return this.$store.pageTitle;
		},
	},
};

</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

.title-anim {
	display: block;
	position: relative;
	perspective: 500px;

	span {
		display: block;
		width: 100%;
		transform-origin: center center -1rem;
	}
}

.title-leave-to {
	transform: rotateX(90deg);
}

.title-enter-from {
	transform: rotateX(-90deg);
	opacity: 0;
}

.title-enter-to {
	transform: rotateX(0);
	opacity: 1;
}

.title-leave-active {
	position: absolute;
	transition: transform .2s ease-in;
}

.title-enter-active {
	transition: transform .2s ease-out, opacity 0s;
	transition-delay: .17s;
}

</style>
